import { defineStore } from "pinia";
import { fleetStoreGetters } from "@/stores/fleet/fleet.getters.bridge";
import { createPlanManagerState } from "./plan-manager/plan-manager.state";
import { applyAnalysisData, applySeferPlani, savePlanEntry, } from "./plan-manager/plan-manager.sync";
import { planManagerAsyncActions } from "./plan-manager/plan-manager.actions";
/**
 * Plan dosyası / analiz yükleme state (Pinia).
 * Vuex kaynak: `store/modules/planManager.js` — namespace `planManager`.
 * micro-7-2: state + sync actions + async actions; filo getters → fleet bridge (micro-6-4).
 */
export const usePlanManagerStore = defineStore("planManager", {
    state: () => createPlanManagerState(),
    getters: fleetStoreGetters,
    actions: {
        savePlanEntry(payload) {
            savePlanEntry(this, payload);
        },
        setAnalysisData(data) {
            applyAnalysisData(this, data);
        },
        setDirectoryHandle(handle) {
            this.directoryHandle = handle;
        },
        setCurrentMethod(method) {
            this.currentMethod = method;
        },
        setDolulukHedefi(hedef) {
            this.dolulukHedefi = hedef;
        },
        setOptimizasyonParametreleri(params) {
            this.optimizasyonParametreleri = params;
        },
        setAnalizSonuclari(sonuclar) {
            this.analizSonuclari = sonuclar;
        },
        setSeferPlani(plan) {
            applySeferPlani(this, plan);
        },
        setGidisVerileri(veriler) {
            this.gidisVerileri = veriler;
        },
        setDonusVerileri(veriler) {
            this.donusVerileri = veriler;
        },
        setHatVerileri(veriler) {
            this.hatVerileri = veriler;
        },
        setYolcuVerileri(veriler) {
            this.yolcuVerileri = veriler;
        },
        setGrafikVerileri(veriler) {
            this.grafikVerileri = veriler;
        },
        setModelVerileri(veriler) {
            this.modelVerileri = veriler;
        },
        ...planManagerAsyncActions,
    },
});
